/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Box/theme';

export const BoxTheme = theme;
